export default function loggingInDev(label = "=>", loggingStatement) {
  if (process.env.NODE_ENV === "development") {
    // console.log(`label ${loggingStatement}`);
    console.log(label, loggingStatement);
  }
}
